export const formatPhoneNumber = (phoneNumber: string | undefined): string => {
    if (!phoneNumber) return '';

    // Remove all non-numeric characters
    const cleaned = phoneNumber.replace(/\D/g, '');

    // Return early if it doesn't look like a standard phone number
    if (cleaned.length < 9 || cleaned.length > 11) {
        return phoneNumber;
    }

    // For 10-digit numbers (e.g., 02-123-4567 or 010-123-4567)
    if (cleaned.length === 10) {
        if (cleaned.startsWith('02')) {
            // 02-XXX-XXXX
            return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
        } else {
            // XXX-XXX-XXXX
            return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }
    }

    // For 11-digit numbers (e.g., 010-1234-5678)
    if (cleaned.length === 11) {
        return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}-${cleaned.slice(7)}`;
    }

    // For 9-digit numbers (e.g., 02-123-4567 -> oops, that's 9)
    if (cleaned.length === 9 && cleaned.startsWith('02')) {
        return `${cleaned.slice(0, 2)}-${cleaned.slice(2, 5)}-${cleaned.slice(5)}`;
    }

    return phoneNumber;
};
